import { createContact, getSubscribedStatus } from "@app/scripts/api/emarsys"

class EmarsysFooterForm extends HTMLElement {
  form1: HTMLFormElement
  form2: HTMLFormElement
  form1ErrorState: HTMLDivElement
  form2ErrorState: HTMLDivElement
  successContainer: HTMLDivElement

  email: string = ""

  constructor() {
    super()

    this.form1 = this.querySelector(".signup-form-step-1")!
    this.form2 = this.querySelector(".signup-form-step-2")!
    this.form1ErrorState = this.form1.querySelector(".error-state")!
    this.form2ErrorState = this.form2.querySelector(".error-state")!
    this.successContainer = this.querySelector(".success-container")!

    console.assert(this.form1, "Signup form step 1 not found")
    console.assert(this.form2, "Signup form step 2 not found")
    console.assert(this.form1ErrorState, "Error state for form 1 not found")
    console.assert(this.form2ErrorState, "Error state for form 2 not found")

    this.form1.addEventListener("submit", this.handleForm1Submit)
    this.form2.addEventListener("submit", this.handleForm2Submit)
    this.form2!.querySelector(".no-phone-submit")!.addEventListener(
      "click",
      () => this.handleForm2Submit(undefined, true)
    )
  }

  handleForm1Submit = async (event: SubmitEvent) => {
    event.preventDefault()

    this.email =
      (this.form1.querySelector('input[type="email"]') as HTMLInputElement)
        .value || ""

    try {
      const { isSubscribed } = await getSubscribedStatus(this.email)

      if (isSubscribed) {
        this.showErrorForm1(
          "This email address already exists. Please use a different email address."
        )
      } else {
        this.showForm2()
      }
    } catch (error) {
      console.error("Error calling placeholder API:", error)
      this.showErrorForm1("Unknown error. Please try again later.")
    }
  }

  handleForm2Submit = async (e?: SubmitEvent, noPhone?: boolean) => {
    e?.preventDefault()

    const data: { [key: string]: string } = {
      contactListId: this.dataset.contactListId || "",
      countryCode: this.dataset.countryCode || "",
      email: this.email,
    }

    if (!noPhone) {
      const mobileInput = this.form2!.querySelector(
        'input[name="phone"]'
      ) as HTMLInputElement
      data.mobile = mobileInput.value
      data.smsOptIn = "true"
    }

    let res: unknown
    try {
      res = await createContact(data)
    } catch (e) {
      console.error(e)
      this.showErrorForm2("Unknown error. Please try again later.")
      return
    }

    if (this.dataset.storageKey) {
      localStorage.setItem(this.dataset.storageKey, "true")
    }

    this.showSuccess()

    console.debug("[Emarsys footer form] Form submitted successfully", res)
  }

  showForm2 = () => {
    this.form1.style.display = "none"
    this.form2.style.display = "block"
    ;(
      this.form2.querySelector('input[type="tel"]') as HTMLInputElement
    )?.focus()
  }

  showErrorForm1 = (message: string) => {
    this.form1ErrorState.textContent = message
    this.form1ErrorState.style.display = "block"
  }

  showErrorForm2 = (message: string) => {
    this.form2ErrorState.textContent = message
    this.form2ErrorState.style.display = "block"
  }

  showSuccess = () => {
    this.querySelector(".thb-widget-title")!.textContent =
      this.dataset.successTitle || "Thank you for subscribing."

    this.form2.style.display = "none"
    this.successContainer.style.display = "block"
  }
}

customElements.define("emarsys-footer-form", EmarsysFooterForm)
